import React, { useState, useEffect, useContext } from 'react';
import {Stack, Collapsible, Button, Icon} from '@shopify/polaris';
import {ChevronRightMinor, ChevronDownMinor, ExternalSmallMinor} from '@shopify/polaris-icons';
import EditNode from './EditNode'
import EditNodeDrop from './EditNodeDrop'
import {CourseTreeContext} from '../contexts/CourseTree'
import { useDrag } from 'react-dnd';

export default function EditNodes(props) {
  const [courseTree, updateCourseTree, isOpen, toggleOpen] = useContext(CourseTreeContext)

  const item = props.item || {}
  const open = isOpen(item.id)
  const isContainer = item.type == 'container'

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'node',
    item: {id: item.id},
    canDrag: (monitor) => true,
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging()
      }
    }
    ,
  }), [item.id, 'node']);


  return (<div ref={drag} className={`edit-nodes edit-nodes-${item.type} ${isDragging ? 'dragging' : ''}`}>
    <EditNodeDrop
      beforeNodeId={item.id}
      afterNodeId={props.prevNode && props.prevNode.id}
    />
    <Stack>
      { isContainer ?
        <span className="openClose"><Button plain icon={<Icon source={open ? ChevronDownMinor : ChevronRightMinor} />} onClick={() => toggleOpen(item.id)}/></span> : null
      }
      <EditNode item={item} />
    </Stack>
    {
      isContainer ?
        (
          <div><Collapsible
            open={open}
            id="basic-collapsible"
            transition={{duration: '500ms', timingFunction: 'ease-in-out'}}
            expandOnPrint
          >
           {
             open ?
             <div className="collapsible">
               { (item.child_nodes || []).map((child_node, index) => {
                   return <EditNodes item={child_node} key={child_node.id}
                     prevNode={index > 0 && item.child_nodes[index - 1]}
                     nextNode={item.child_nodes[index + 1]}
                   />
                 })
               }
               { !(item.child_nodes || []).length ? <EditNodeDrop intoNodeId={item.id} /> : null}
             </div> : null
           }
          </Collapsible></div>
      ) : null
    }
    { !props.nextNode ?
      <EditNodeDrop afterNodeId={item.id} />
      : null
    }
  </div>)
}
